import { cn } from "@/lib/utils";

export function AllIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-5 text-white", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M4.394 5.852a4.22 4.22 0 00-2.853 2.02c-.767 1.338-.716 2.977.135 4.292.09.138.31.403.488.587 1.487 1.538 3.843 1.709 5.567.403.116-.088.675-.619 1.24-1.18l1.03-1.019 1.03 1.02c1.05 1.042 1.265 1.23 1.697 1.484a4.216 4.216 0 004.417-.118 5.2 5.2 0 001.052-.998c1.515-2.043.81-4.956-1.476-6.106-.676-.341-1.247-.46-2.056-.431-.58.02-.904.085-1.377.271-.686.27-1.063.566-2.284 1.792-.523.524-.973.953-1 .953-.028 0-.495-.442-1.039-.982-1.1-1.093-1.134-1.123-1.48-1.356a4.134 4.134 0 00-1.582-.635c-.383-.066-1.133-.065-1.51.003zm1.25 1.47c.141.028.365.09.495.14.46.174.69.36 1.772 1.436l1.024 1.019-.813.8c-1.398 1.378-1.552 1.5-2.114 1.679a2.643 2.643 0 01-1.69 0c-.412-.13-.696-.311-1.06-.674-.275-.272-.347-.37-.483-.652a2.306 2.306 0 01-.269-1.16c0-.61.167-1.106.543-1.605.575-.765 1.635-1.166 2.594-.982zm9.864.037c.295.078.808.339 1.038.528.428.354.782.924.899 1.447.086.389.056 1.028-.064 1.377a2.459 2.459 0 01-.656 1.031c-.342.339-.639.526-1.027.65-.594.188-1.17.189-1.72.002-.574-.196-.857-.423-2.172-1.748l-.745-.751 1.034-1.011c.677-.663 1.119-1.067 1.281-1.172.28-.18.614-.317.953-.388.283-.06.885-.042 1.178.035z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function NotPlayedIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-5 text-white", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.667 16.601V2.728a1 1 0 011.492-.87l12.04 6.805a1 1 0 01.014 1.733l-12.04 7.067a1 1 0 01-1.506-.862z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PlayedIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-5 text-white", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M3.335 9.565c-1.057-1.12-2.748.586-1.638 1.653 1.374 1.44 2.748 2.933 4.175 4.32.635.586 1.11.586 1.692 0L17.659 5.404c1.057-1.12-.581-2.826-1.691-1.706L6.77 12.977 3.335 9.566z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function WishlistIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-5 text-white", className)}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.666 0h-10c-1.1 0-2 1-2 2.222V20l7-3.333 7 3.333V2.222c0-1.222-.9-2.222-2-2.222z"
        fill="currentColor"
      />
    </svg>
  );
}
